module.exports = __webpack_public_path__ + "static/img/hb_17-min.dae8b0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_17-min.png
// module id = h4gU
// module chunks = 1